import { selectors as loadFileSelectors } from './load-file'

import type { BaseState } from './types'

//  TODO(Jr, 1/18/24): use i18n here!
export const initialize = (store: Record<string, any>): void => {
  if (_NODE_ENV_ === 'production') {
    window.onbeforeunload = (_e: unknown) => {
      // NOTE: the custom text will be ignored in modern browsers
      return loadFileSelectors.getHasUnsavedChanges(
        store.getState() as BaseState
      )
        ? 'Are you sure you want to leave? You will lose any unsaved changes.'
        : undefined
    }
  }
}
